import { option } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';

/**
 * Pluck (Option)
 *
 * Plucks a property value from an object.
 * Takes an Object key and Option<Object> and returns an Option<Value>
 *
 * string -> Option<Object> -> Option<Value>
 */
export function pluckOption<TObject, TValue>(fieldName: keyof TObject) {
  return flow(
    option.map((data: TObject) => data[fieldName] as TValue), // Purposely not using Record.lookup
    option.chain(option.fromNullable),
  );
}

/**
 * Pluck
 *
 * Plucks a property value from an object.
 * Takes an Object key and Object and returns an Option<Value>
 *
 * string -> Object -> Option<Value>
 */
export function pluck<TObject, TValue>(fieldName: keyof TObject) {
  return (value?: TObject | null) =>
    pipe(value, option.fromNullable, pluckOption<TObject, TValue>(fieldName));
}
